import { Button, Col, message, Modal, Row, Table } from "antd";
import { useEffect, useState } from "react";
import API from "../../../../services/api-request";
import FilterMenu from "./filter-menu";
import { ExclamationCircleFilled } from "@ant-design/icons";
import AddMaterialHandling from "./modal-add-material-handling";
import EditMaterialHandling from "./modal-edit-material-handling";

const { confirm } = Modal;

const MaterialHandling = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  const getMaterialHandling = () => {
    setLoading(true);
    API.Get("material-handling")
      .then((res) => {
        const data = res?.data;

        setData(data);
      })
      .catch((err) => {
        console.log(err);
        message.error("Failed to fetch Material Handling!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const showDeleteConfirm = (data) => {
    confirm({
      title: `Delete ${data.key} - ${data.type}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${data.key} - ${data.type}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`material-handling/${data.id}`)
          .then(() => {
            message.success("Material Handling has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete Material Handling");
            console.error(err);
          })
          .finally(() => {
            getMaterialHandling();
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  useEffect(() => {
    getMaterialHandling();
  }, []);

  const columns = [
    {
      title: "No.",
      key: "id",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Key",
      dataIndex: "key",
      key: "key",
      sorter: (a, b) => {
        if (a.key === null || a.key === "-") return 1;
        if (b.key === null || b.key === "-") return -1;
        return a.key.localeCompare(b.key);
      },
      render: (key) => (key ? key : "-"),
    },
    {
      title: "Cost",
      dataIndex: "cost",
      key: "cost",
      sorter: (a, b) => {
        if (a.cost === null || a.cost === "-") return 1;
        if (b.cost === null || b.cost === "-") return -1;
        return a.cost.localeCompare(b.cost);
      },
      render: (cost) => (cost ? cost : "-"),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      sorter: (a, b) => {
        if (a.type === null || a.type === "-") return 1;
        if (b.type === null || b.type === "-") return -1;
        return a.type.localeCompare(b.type);
      },
      render: (type) => (type ? type : "-"),
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      render: (data) => {
        return (
          <Row align="middle" gutter={[8, 8]}>
            <Col>
              <Button
                type="primary"
                onClick={() => {
                  setSelectedData({ ...data });
                  onShowEdit(true);
                }}
              >
                Edit
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm(data);
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  return (
    <>
      <FilterMenu onShowAdd={onShowAdd} />
      <Table columns={columns} dataSource={data} loading={loading} />

      <AddMaterialHandling
        showAdd={showAdd}
        onShowAdd={onShowAdd}
        onGetMaterialHandling={getMaterialHandling}
      />

      <EditMaterialHandling
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        onGetMaterialHandling={getMaterialHandling}
        selectedData={selectedData}
      />
    </>
  );
};

export default MaterialHandling;
